import { executeStructuredModelRequest } from '../../executeStructuredModelRequest';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import { buildWellnessInsightRequest } from './runner';
import type { WellnessInsightExecutionResult, WellnessInsightInput } from './types';
import { parseWellnessInsightAssistantResponse } from './validators';

export const executeWellnessInsightRequest = async (
  response: WellnessInsightInput,
): Promise<WellnessInsightExecutionResult> => {
  const output = buildWellnessInsightRequest(response);
  if (!output) return { status: 'no_eligible_metrics', selectedMetrics: [] };

  const { selectedMetrics, request } = output;
  const result = await executeStructuredModelRequest({
    request,
    profile: transactionActionExecutionProfiles.wellness_insights,
    capability: 'wellness_insights',
    parseResponse: (assistantResponse) => parseWellnessInsightAssistantResponse(selectedMetrics, assistantResponse),
  });

  return result.status === 'success'
    ? { status: 'insights', selectedMetrics, insights: result.data }
    : { status: 'request_failed', selectedMetrics, error: result.error };
};
